import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

import LoadingBox from "./LoadingBox";
import MessageBox from "./MessageBox";
import { useSlider } from "../features/useSlider";

const HeroSlider = ({ config }) => {
  const { isLoading, error, sliders } = useSlider();
  // const [autoPlay, setAutoPlay] = useState(true);
  const autoPlay = true;

  if (isLoading) return <LoadingBox />;
  if (error) return <MessageBox variant="danger">{error[0]}</MessageBox>;

  let SliderImages;

  if (config.home) {
    SliderImages = sliders.filter((item) => item.homepage === config.home);
  }
  if (config.faculty) {
    SliderImages = sliders.filter((item) =>
      item.faculty.some((entry) => entry.collegecode === config.faculty)
    );
  }
  if (config.department) {
    SliderImages = sliders.filter((item) =>
      item.department.some((entry) => entry.depid === config.department)
    );
  }

  return (
    <div style={{ display: autoPlay ? "block" : "none" }}>
      {/* Render Carousel only if autoPlay is true */}
      <Carousel
        autoPlay={autoPlay}
        showArrows={true}
        showIndicators={true}
        showThumbs={false}
        showStatus={false}
        infiniteLoop={true}
        interval={3000}
        stopOnHover={false}
        
      >
        {SliderImages?.map((obj) => (
          <HeroSliderImages object={obj} key={obj.id} />
        ))}
      </Carousel>
    </div>
  );
};

export default HeroSlider;

function HeroSliderImages({ object }) {
  return (
    <div key={object.id}>
      <img className="img-fluid" src={object.image} alt={object.name} />
    </div>
  );
}
